<template>
  <div class="hello">
    <div class="">

      <!-- Header -->
      <header class="header">
        <div class="header__container flex-space">
          <a href="/" class="header__brand" style="text-decoration:none;"><span style="font-size: 2.4rem; font-weight: 700; color: #fff;">vim.is</span></a>
          <nav class="nav">
            <ul class="nav__menu">
              <li><a class="nav__menu--item" href="/overview" style="margin-right: 1.5rem; color: #fff; text-decoration: none; font-size: 1.5rem;">Curriculum</a></li>
              <li><a class="nav__menu--item btn btn__default" href="/login">Log in</a></li>
            </ul>
          </nav>
          <nav class="mobile-nav">
            <ul class="nav__menu">
              <li><a class="nav__menu--item" href="/overview" style="margin-right: 1rem; color: #fff; text-decoration: none;">Curriculum</a></li>
              <li><a class="nav__menu--item" href="/login">Log in</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <main>

        <!-- HERO: short, confident, gets out of the way -->
        <section>
          <div class="hero pad-m">
            <div class="container">
              <div class="hero-content m-a">
                <br><br><br>
                <h1 class="hero-content__title mb-m">Learn vim.<br>By actually doing it.</h1>
                <h2 class="subtitle">Interactive exercises in a real editor. No reading. No videos.<br>Try one right now.</h2>
                <br><br>
                <div class="v-hero-cta">
                  <a href="#exercise" class="v-btn-white" v-on:click="focusEditor">Try a free exercise</a>
                </div>
                <br>
                <a href="https://www.producthunt.com/posts/master-vim?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-master-vim" target="_blank">
                  <img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=294684&theme=light" alt="Master Vim on Product Hunt" style="width: 200px; height: 43px;" width="200" height="43" />
                </a>
              </div>
            </div>
          </div>
        </section>

        <!-- FREE EXERCISE: the product sells itself -->
        <section class="v-exercise-section pad-l" id="exercise">
          <div class="container">
            <div class="text-center v-exercise-hd">
              <a name="exercise"></a>
              <h2 class="section-title">{{this.data[this.index].title}}</h2>
              <p class="v-hint">
                <kbd>ESC</kbd> for command mode &nbsp;&middot;&nbsp;
                <kbd>h</kbd> <kbd>l</kbd> to move &nbsp;&middot;&nbsp;
                move over <kbd>%</kbd> and press <kbd>x</kbd> to delete &nbsp;&middot;&nbsp;
                <kbd>u</kbd> to undo
              </p>
            </div>

            <div class="v-editor-wrap" id="parent">
              <VueCodeEditor
                @init="editorInit"
                theme="monokai"
                width="100%"
                id="editor"
                name="editor"
                v-on:input="onChange"
                v-model=answer
                ref="editor"
                :options="{
                  fontSize: 18,
                  highlightActiveLine: true,
                  showLineNumbers: true,
                  tabSize: 2,
                }"
              />>
            </div>

            <div class="v-exercise-footer">
              <div>
                <span class="btn btn__primary">Exercise: <span class="score">{{this.index}} / {{this.data.length}}</span></span>
                &nbsp;
                <span class="btn btn_reset" v-on:click="reset(); focusEditor();">Reset</span>
              </div>
            </div>
          </div>
        </section>

        <!-- CURRICULUM: desire through scarcity, they just felt the click, now show what they're missing -->
        <section class="v-curriculum pad-l" id="curriculum">
          <div class="container m-a">

            <div class="text-center v-curr-hd">
              <h2 class="section-title">153 exercises waiting.</h2>
              <p class="v-curr-sub">153 lessons, 1,731 practice drills, 15 modules and boss battles. Everything you need to build true vim muscle memory.</p>
            </div>

            <div class="v-cmd-grid">
              <div class="v-cmd-item v-cmd-free">
                <span class="v-cmd-key">h j k l</span>
                <span class="v-cmd-label">Move the cursor</span>
                <span class="v-cmd-tag">FREE</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">w e b</span>
                <span class="v-cmd-label">Jump by word</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">0 ^ $</span>
                <span class="v-cmd-label">Line boundaries</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">i a o</span>
                <span class="v-cmd-label">Insert modes</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">x dw dd</span>
                <span class="v-cmd-label">Targeted delete</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">cw cc C</span>
                <span class="v-cmd-label">Change text</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">u Ctrl-r</span>
                <span class="v-cmd-label">Undo and redo</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">.</span>
                <span class="v-cmd-label">Repeat last edit</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">yy p P</span>
                <span class="v-cmd-label">Yank and paste</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">"a "0</span>
                <span class="v-cmd-label">Registers</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">f t ; ,</span>
                <span class="v-cmd-label">Character search</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">ciw daw</span>
                <span class="v-cmd-label">Word text objects</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">ci" ci'</span>
                <span class="v-cmd-label">Inside quotes</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">ci( ci[ ci{</span>
                <span class="v-cmd-label">Inside blocks</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">dap cip</span>
                <span class="v-cmd-label">Paragraphs</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">v V Ctrl-v</span>
                <span class="v-cmd-label">Visual mode</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">gg G :n</span>
                <span class="v-cmd-label">File navigation</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">/ ? * n N</span>
                <span class="v-cmd-label">Search</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">ma 'a</span>
                <span class="v-cmd-label">Bookmarks</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">:%s/old/new/g</span>
                <span class="v-cmd-label">Global substitute</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">(\w+) $1</span>
                <span class="v-cmd-label">Regex groups</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">:sort</span>
                <span class="v-cmd-label">Sort lines</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">gU gu ~</span>
                <span class="v-cmd-label">Change case</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">Ctrl-a / x</span>
                <span class="v-cmd-label">Increment numbers</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">&gt; &lt; J</span>
                <span class="v-cmd-label">Indent and join</span>
              </div>
              <div class="v-cmd-item">
                <span class="v-cmd-key">BOSS</span>
                <span class="v-cmd-label">7 boss battles</span>
              </div>
            </div>


            <!-- CTA: right after they've seen what they're missing -->
            <div class="v-cta-block" id="pricing">
              <div class="v-cta-inner">
                <div class="v-cta-text">
                  <h3 class="v-cta-title">Unlock all 153 exercises.</h3>
                  <p class="v-cta-sub">Pay once. No subscription. Instant access.</p>
                </div>
                <a href="https://pythoncourses.gumroad.com/l/GRjBCw/u1lm0i3" class="v-buy-btn">
                  Get full access
                </a>
              </div>
            </div>

          </div>
        </section>

        <!-- TESTIMONIALS: reassurance after desire is created -->
        <section class="v-testimonials pad-l">
          <div class="container">
            <div class="v-tgrid">

              <div class="v-tcard v-tcard--featured">
                <div class="v-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
                <blockquote>"I always wanted an interactive way to learn vim. Reading about it does not work. This does."</blockquote>
                <div class="v-tauthor">
                  <img src="vivek.webp" alt="Vivek" class="v-tavatar"/>
                  <div>
                    <span class="v-tname">Vivek</span>
                    <span class="v-trole">Backend Developer</span>
                  </div>
                </div>
              </div>

              <div class="v-tcard">
                <div class="v-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
                <blockquote>"Simple interface. Easy to focus on one task and get the movements into your fingers."</blockquote>
                <div class="v-tauthor">
                  <img src="andrew.webp" alt="Andrew" class="v-tavatar"/>
                  <div>
                    <span class="v-tname">Andrew</span>
                    <span class="v-trole">Software Engineer</span>
                  </div>
                </div>
              </div>

              <div class="v-tcard">
                <div class="v-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
                <blockquote>"Makes coding noticeably faster. I recommend it to anyone who wants more efficiency."</blockquote>
                <div class="v-tauthor">
                  <img src="zahn.jpeg" alt="Zahn" class="v-tavatar"/>
                  <div>
                    <span class="v-tname">Zahn</span>
                    <span class="v-trole">Developer</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <!-- FINAL CTA -->
        <section class="v-final pad-l">
          <div class="container text-center">
            <h2 class="v-final-title">You have been meaning to do this for a while.</h2>
            <p class="v-final-sub">Thirty minutes of practice and it starts to click.</p>
            <a href="https://pythoncourses.gumroad.com/l/GRjBCw/u1lm0i3" class="v-buy-btn" style="display:inline-block; margin-top: 2rem;">
              Get full access
            </a>
            <br>
            <a href="#exercise" class="v-final-alt" v-on:click="focusEditor">Try the free exercise first</a>
          </div>
        </section>

      </main>

      <!-- FEATURED ON -->
      <section class="v-featured">
        <div class="v-featured-hd">
          <p class="v-featured-label">Featured on</p>
        </div>

        <div class="featured-marquee">
          <div class="featured-track">
            <ul class="featured-group">
              <li v-for="b in featuredBadges" :key="b.badge">
                <a :href="b.href" target="_blank" rel="noopener" class="featured-link">
                  <img :src="b.badge" :alt="b.name" :width="b.w" :height="b.h" loading="lazy" decoding="async" />
                </a>
              </li>
            </ul>
            <ul class="featured-group" aria-hidden="true">
              <li v-for="b in featuredBadges" :key="'dup-' + b.badge">
                <a :href="b.href" target="_blank" rel="noopener" tabindex="-1" class="featured-link">
                  <img :src="b.badge" :alt="b.name" :width="b.w" :height="b.h" loading="lazy" decoding="async" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

        <!-- Footer -->
        <footer id="footer">
        <div class="container">
          <div class="footer-bottom">
            <div class="footer-bottom__left">
              <div class="footer-bottom__nav">
                <a href="/overview" class="footer-bottom__link">Curriculum (All 153 Exercises)</a>
                <span class="footer-bottom__sep">&middot;</span>
                <a href="/login" class="footer-bottom__link">Log in</a>
                <span class="footer-bottom__sep">&middot;</span>
                <a href="https://pythoncourses.gumroad.com/l/GRjBCw/u1lm0i3" class="footer-bottom__link" target="_blank" rel="noopener noreferrer">Get Full Access</a>
              </div>
              <p class="footer-bottom__copyright">Copyright &copy; 2021-2026 Frank Anemaet &middot; frank at fastmail dot org</p>
            </div>
            <ul class="footer-bottom__social">
              <li><a class="footer-bottom__social--item" href="https://twitter.com/share?url=https%3A%2F%2Fvim.is&text=Learn%20vim%20by%20actually%20doing%20it" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><ion-icon name="logo-twitter"></ion-icon></a></li>
              <li><a class="footer-bottom__social--item" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fvim.is" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><ion-icon name="logo-facebook"></ion-icon></a></li>
              <li><a class="footer-bottom__social--item" href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fvim.is" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><ion-icon name="logo-linkedin"></ion-icon></a></li>
            </ul>
          </div>
        </div>
      </footer>

    </div>
  </div>
</template>

<script>

window.ace.require = window.ace.acequire;
import VueCodeEditor from 'vue2-code-editor';

export default {
  mounted() {
    const plugin = document.createElement("script");
    plugin.setAttribute("src", "https://testimonial.to/js/iframeResizer.min.js");
    plugin.async = true;
    document.head.appendChild(plugin);
    if (window.location.hash === '#exercise') this.focusEditor();
  },
  components: { VueCodeEditor },
  name: 'HelloWorld',
  metaInfo: { title: 'vim.is - Interactive Vim Exercises' },
  props: { msg: String },
  created: function() { this.getData(); },
  methods: {
    getData() {
      fetch('../landing.json')
        .then(response => response.json())
        .then(data => (this.data = data))
        .then(() => { this.answer = this.data[this.index].placeholder; });
    },
    editorInit: function(editor) {
      this.aceEditor = editor
      require('brace/mode/html')
      require('brace/mode/python')
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/theme/dracula')
      require('brace/theme/monokai')
      editor.setOption('fontSize', '16pt')
      editor.setOption('vScrollBarAlwaysVisible', true)
      editor.setOption('theme', 'ace/theme/textmate')
      require('brace/keybinding/vim')
      editor.setKeyboardHandler('ace/keyboard/vim')
    },
    editorRender: function(output) {
      require('brace/mode/html')
      require('brace/mode/python')
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/theme/chaos')
      require('brace/theme/monokai')
      output.setOption('fontSize', '16pt')
      output.setOption('vScrollBarAlwaysVisible', true)
      output.setOption('theme', 'ace/theme/textmate')
    },
    focusEditor: function() {
      setTimeout(() => { if (this.aceEditor) this.aceEditor.focus(); }, 100)
    },
    onChange: function() { this.correct(); },
    reset: function() { this.index = 0; this.getData(); },
    correct: function() {
      if (this.data[this.index].solution == this.answer) {
        if (this.index >= this.data.length - 1) {
          this.reset();
          document.getElementById("pricing").scrollIntoView();
        }
        this.oldIndex = 0;
        this.answer = '';
        this.score = this.score + 1;
        this.index = this.index + 1;
        this.totalTime += this.elapsedTime;
        setTimeout(() => { this.answer = this.data[this.index].placeholder; }, 10)
      }
    },
  },
  data: function() {
    return {
      elapsedTime: 1, totalTime: 1, averageTime: 1,
      timer: undefined, answer: "", score: 0, index: 0,
      data: [{},{}], title: '', exercise: [],
      featuredBadges: [
        { name: 'Unite List', href: 'https://unitelist.com/product/vim', badge: '/unitelist-badge.png', w: 111, h: 36 },
        { name: 'Best Tool Vault', href: 'https://besttoolvault.com/tool/vim', badge: '/besttoolvault-badge.png', w: 143, h: 36 },
        { name: 'Trustiner', href: 'https://trustiner.com/product/vim', badge: '/trustiner-badge.png', w: 108, h: 36 },
        { name: 'That App Show', href: 'https://thatappshow.com/product/vim', badge: '/thatappshow-badge.png', w: 145, h: 36 },
        { name: 'We Like Tools', href: 'https://weliketools.com/tool/vim', badge: '/weliketools-badge.png', w: 137, h: 36 },
        { name: 'Product Wing', href: 'https://productwing.com/product/vim', badge: '/productwing-badge.png', w: 135, h: 36 },
        { name: 'Hunt for Tools', href: 'https://huntfortools.com/tool/vim', badge: '/huntfortools-badge.png', w: 138, h: 36 },
        { name: 'Solver Tools', href: 'https://solvertools.com/tool/vim', badge: '/solvertools-badge.png', w: 128, h: 36 },
        { name: 'Launch Scroll', href: 'https://launchscroll.com/product/vim', badge: '/launchscroll-badge.png', w: 136, h: 36 },
        { name: 'Toshi List', href: 'https://toshilist.com/product/vim', badge: '/toshilist-badge.png', w: 112, h: 36 },
        { name: 'Startup Vessel', href: 'https://startupvessel.com/product/vim', badge: '/startupvessel-badge.png', w: 140, h: 36 },
        { name: 'Product List Dir', href: 'https://productlistdir.com/product/vim', badge: '/productlistdir-badge.png', w: 148, h: 36 },
        { name: 'My Start Tools', href: 'https://mystarttools.com/tool/vim', badge: '/mystarttools-badge.png', w: 139, h: 36 },
        { name: 'Beam Tools', href: 'https://beamtools.com/tool/vim', badge: '/beamtools-badge.png', w: 123, h: 36 },
        { name: 'Appsy Tools', href: 'https://appsytools.com/tool/vim', badge: '/appsytools-badge.png', w: 128, h: 36 },
        { name: 'Stack Directory', href: 'https://stackdirectory.com/product/vim', badge: '/stackdirectory-badge.png', w: 146, h: 36 },
        { name: 'Software Bolt', href: 'https://softwarebolt.com/product/vim', badge: '/softwarebolt-badge.png', w: 135, h: 36 },
        { name: 'Ash List', href: 'https://ashlist.com/product/vim', badge: '/ashlist-badge.png', w: 105, h: 36 },
        { name: 'SaaS Tools Dir', href: 'https://saastoolsdir.com/product/vim', badge: '/saastoolsdir-badge.png', w: 142, h: 36 },
        { name: 'SaaS Roots', href: 'https://saasroots.com/product/vim', badge: '/saasroots-badge.png', w: 123, h: 36 },
        { name: 'Top Trend Tools', href: 'https://toptrendtools.com/tool/vim', badge: '/toptrendtools-badge.png', w: 149, h: 36 },
        { name: 'Tool Signal', href: 'https://toolsignal.com/tool/vim', badge: '/toolsignal-badge.png', w: 120, h: 36 },
        { name: 'Source Dir', href: 'https://sourcedir.com/product/vim', badge: '/sourcedir-badge.png', w: 117, h: 36 },
        { name: 'App Hub List', href: 'https://apphublist.com/products/vim', badge: '/apphublist-badge.png', w: 130, h: 36 },
        { name: 'App Networker', href: 'https://appnetworker.com/products/vim', badge: '/appnetworker-badge.png', w: 130, h: 36 },
        { name: 'SaaS Avenue', href: 'https://saasavenue.com/products/vim', badge: '/saasavenue-badge.png', w: 130, h: 36 },
        { name: 'SaaS Badge', href: 'https://saasbadge.com/products/vim', badge: '/saasbadge-badge.png', w: 130, h: 36 },
        { name: 'SaaS Branch', href: 'https://saasbranch.com/products/vim', badge: '/saasbranch-badge.png', w: 130, h: 36 },
        { name: 'SaaS Crawler', href: 'https://saascrawler.com/products/vim', badge: '/saascrawler-badge.png', w: 130, h: 36 },
        { name: 'SaaS Networker', href: 'https://saasnetworker.com/products/vim', badge: '/saasnetworker-badge.png', w: 130, h: 36 },
        { name: 'SaaS Scanner', href: 'https://saasscanner.com/products/vim', badge: '/saasscanner-badge.png', w: 130, h: 36 },
        { name: 'SaaS State', href: 'https://saasstate.com/products/vim', badge: '/saasstate-badge.png', w: 130, h: 36 },
        { name: 'SaaS Territory', href: 'https://saasterritory.com/products/vim', badge: '/saasterritory-badge.png', w: 130, h: 36 },
        { name: 'Tool Dynamo', href: 'https://tooldynamo.com/tools/vim', badge: '/tooldynamo-badge.png', w: 130, h: 36 },
        { name: 'Tool Ignite', href: 'https://toolignite.com/tools/vim', badge: '/toolignite-badge.png', w: 130, h: 36 },
        { name: 'Toolkit Index', href: 'https://toolkitindex.com/products/vim', badge: '/toolkitindex-badge.png', w: 130, h: 36 },
        { name: 'Tool Networker', href: 'https://toolnetworker.com/tools/vim', badge: '/toolnetworker-badge.png', w: 130, h: 36 },
        { name: 'Tool Parade', href: 'https://toolparade.com/tools/vim', badge: '/toolparade-badge.png', w: 130, h: 36 },
        { name: 'SubmitMatic', href: 'https://submitmatic.com/product/vim', badge: 'https://submitmatic.com/static/images/badge-dark.png', w: 130, h: 36 },
        { name: 'Good AI Tools', href: 'https://goodaitools.com/ai/vim', badge: '/goodaitools-badge.png', w: 130, h: 36 },
        { name: 'Million Dot Homepage', href: 'https://milliondothomepage.com/product/vim', badge: '/milliondothomepage-badge.png', w: 130, h: 36 },
        { name: 'LaunchClash', href: 'https://launchclash.com/product/vim', badge: '/launchclash-badge.png', w: 130, h: 36 },
        { name: 'ShinyLaunch', href: 'https://shinylaunch.com/product/vim', badge: '/shinylaunch-badge.png', w: 130, h: 36 },
        { name: 'Acid Tools', href: 'https://acidtools.com/ai/vim', badge: '/acidtools-badge.png', w: 130, h: 36 },
        { name: 'AIGC160', href: 'https://aigc160.com/ai/vim', badge: '/aigc160-badge.png', w: 130, h: 36 },
        { name: 'AI Tech Viral', href: 'https://aitechviral.com/ai/vim', badge: '/aitechviral-badge.png', w: 130, h: 36 },
        { name: 'AI Toolzs', href: 'https://aitoolzs.com/ai/vim', badge: '/aitoolzs-badge.png', w: 130, h: 36 },
        { name: 'AIX Collection', href: 'https://aixcollection.com/ai/vim', badge: '/aixcollection-badge.png', w: 130, h: 36 },
        { name: 'Appa List', href: 'https://appalist.com/ai/vim', badge: '/appalist-badge.png', w: 130, h: 36 },
        { name: 'Latest AI Updates', href: 'https://latestaiupdates.com/ai/vim', badge: '/latestaiupdates-badge.png', w: 130, h: 36 },
        { name: 'My Launch Stash', href: 'https://mylaunchstash.com/product/vim', badge: '/mylaunchstash-badge.png', w: 130, h: 36 },
        { name: 'PowerUp Tools', href: 'https://poweruptools.com/ai/vim', badge: '/poweruptools-badge.png', w: 130, h: 36 },
        { name: 'SaaS Field', href: 'https://saasfield.com/ai/vim', badge: '/saasfield-badge.png', w: 130, h: 36 },
        { name: 'SaaS Wheel', href: 'https://saaswheel.com/product/vim', badge: '/saaswheel-badge.png', w: 130, h: 36 },
        { name: 'Smart Kithub', href: 'https://smartkithub.com/product/vim', badge: '/smartkithub-badge.png', w: 130, h: 36 },
        { name: 'Startup AIdeas', href: 'https://startupaideas.com/ai/vim', badge: '/startupaideas-badge.png', w: 130, h: 36 },
        { name: 'Startup Benchmarks', href: 'https://startupbenchmarks.com/product/vim', badge: '/startupbenchmarks-badge.png', w: 130, h: 36 },
        { name: 'Super AI Boom', href: 'https://superaiboom.com/ai/vim', badge: '/superaiboom-badge.png', w: 130, h: 36 },
        { name: 'The App Tools', href: 'https://theapptools.com/ai/vim', badge: '/theapptools-badge.png', w: 130, h: 36 },
        { name: 'The Core Tools', href: 'https://thecoretools.com/tool/vim', badge: '/thecoretools-badge.png', w: 130, h: 36 },
        { name: 'The Key Tools', href: 'https://thekeytools.com/ai/vim', badge: '/thekeytools-badge.png', w: 130, h: 36 },
        { name: 'The Mega Tools', href: 'https://themegatools.com/tool/vim', badge: '/themegatools-badge.png', w: 130, h: 36 },
        { name: 'Tiny Tool Hub', href: 'https://tinytoolhub.com/tool/vim', badge: '/tinytoolhub-badge.png', w: 130, h: 36 },
        { name: 'Tool Cosmos', href: 'https://toolcosmos.com/tool/vim', badge: '/toolcosmos-badge.png', w: 130, h: 36 },
        { name: 'Tool Find Dir', href: 'https://toolfinddir.com/ai/vim', badge: '/toolfinddir-badge.png', w: 130, h: 36 },
        { name: 'Tool Journey', href: 'https://tooljourney.com/tool/vim', badge: '/tooljourney-badge.png', w: 130, h: 36 },
        { name: 'Tool Prism', href: 'https://toolprism.com/ai/vim', badge: '/toolprism-badge.png', w: 130, h: 36 },
        { name: 'Tools List HQ', href: 'https://toolslisthq.com/tool/vim', badge: '/toolslisthq-badge.png', w: 130, h: 36 },
        { name: 'Tools Under Radar', href: 'https://toolsunderradar.com/tool/vim', badge: '/toolsunderradar-badge.png', w: 130, h: 36 },
      ],
    }
  },
}

</script>

<style scoped>

@import '../assets/hero/css2.css';
@import '../assets/hero/normalize.css';
@import '../assets/style.css';
@import '../assets/hero/responsive.css';

/* ---- HERO ---- */

.subtitle {
  color: rgba(255,255,255,0.8);
  font-family: 'Inter', sans-serif;
  font-size: 1.8rem;
  line-height: 1.65;
  font-weight: 300;
}

.v-hero-cta {
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
}

.v-btn-white {
  background: #fff;
  color: #0f172a !important;
  font-family: 'Inter', sans-serif;
  font-size: 1.7rem;
  font-weight: 600;
  padding: 16px 36px;
  border-radius: 8px;
  text-decoration: none;
  transition: opacity 0.15s;
}
.v-btn-white:hover { opacity: 0.88; color: #0f172a !important; }

/* ---- EXERCISE ---- */

.v-exercise-section { background: #fff; }

.v-exercise-hd {
  margin-bottom: 2.4rem;
}

.v-hint {
  font-family: 'Inter', sans-serif;
  font-size: 1.5rem;
  color: #64748b;
  line-height: 1.8;
  margin-top: 1rem;
}

.v-hint kbd {
  font-family: 'JetBrains Mono', monospace;
  font-size: 1.3rem;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-bottom-width: 2px;
  border-radius: 5px;
  padding: 2px 9px;
  color: #334155;
}

.v-editor-wrap {
  width: 100%;
  height: 400px;
  display: block;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 32px rgba(0,0,0,0.12);
}

#parent {
  width: 100%;
  height: 400px;
  display: block;
  position: relative;
}

#editor {
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  margin: 0 auto;
  border-radius: 8px;
}

.v-exercise-footer {
  margin-top: 1.4rem;
  display: flex;
  align-items: center;
}

.btn_reset {
  background: white;
  font-size: 1.6rem;
  cursor: pointer;
  user-select: none;
  padding: 0.8rem 2.4rem;
  border-radius: 6px;
  color: #334155;
  border: 1px solid #cbd5e1;
  font-family: 'Inter', sans-serif;
}
.btn_reset:hover { background: #f8fafc; }

/* ---- CURRICULUM ---- */

.v-curriculum { background: #f8fafc; }

.v-curr-hd {
  margin-bottom: 4rem;
}

.v-curr-sub {
  font-family: 'Inter', sans-serif;
  font-size: 1.7rem;
  color: #64748b;
  margin-top: 0.8rem;
}

.v-cmd-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1rem;
  margin-bottom: 5rem;
}

.v-cmd-item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.4rem 1.8rem;
  display: flex;
  align-items: center;
  gap: 1.4rem;
  position: relative;
}

.v-cmd-free {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.v-cmd-key {
  font-family: 'JetBrains Mono', monospace;
  font-size: 1.6rem;
  font-weight: 600;
  color: #1e293b;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-bottom-width: 2px;
  border-radius: 6px;
  padding: 4px 12px;
  flex-shrink: 0;
  min-width: 72px;
  text-align: center;
}

.v-cmd-free .v-cmd-key {
  background: #dbeafe;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.v-cmd-label {
  font-family: 'Inter', sans-serif;
  font-size: 1.5rem;
  color: #334155;
}

.v-cmd-tag {
  position: absolute;
  top: -1px;
  right: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #1d4ed8;
  background: #dbeafe;
  padding: 2px 8px;
  border-radius: 0 0 6px 6px;
  letter-spacing: 0.04em;
}

/* ---- CTA BLOCK ---- */

.v-cta-block {
  background: #0f172a;
  border-radius: 16px;
  padding: 4rem;
}

.v-cta-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;
  flex-wrap: wrap;
}

.v-cta-title {
  font-family: 'Inter', sans-serif;
  font-size: 2.4rem;
  font-weight: 700;
  color: #f1f5f9;
  margin-bottom: 0.6rem;
}

.v-cta-sub {
  font-family: 'Inter', sans-serif;
  font-size: 1.6rem;
  color: #64748b;
}

.v-buy-btn {
  display: block;
  background: #2563eb;
  color: #fff !important;
  font-family: 'Inter', sans-serif;
  font-size: 1.7rem;
  font-weight: 700;
  padding: 18px 44px;
  border-radius: 10px;
  text-align: center;
  text-decoration: none;
  transition: all 0.15s;
  white-space: nowrap;
  flex-shrink: 0;
}
.v-buy-btn:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(37,99,235,0.4);
  color: #fff !important;
}

/* ---- TESTIMONIALS ---- */

.v-testimonials { background: #fff; }

.v-tgrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.v-tcard {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.v-tcard--featured {
  border-top: 3px solid #2563eb;
  background: #fff;
}

.v-stars {
  color: #f59e0b;
  font-size: 1.4rem;
  letter-spacing: 2px;
}

.v-tcard blockquote {
  font-family: 'Inter', sans-serif;
  font-size: 1.6rem;
  color: #334155;
  line-height: 1.65;
  margin: 0;
  font-style: normal;
  flex: 1;
}

.v-tauthor {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-top: 1.2rem;
  border-top: 1px solid #e2e8f0;
}

.v-tavatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.v-tname {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
}

.v-trole {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 1.3rem;
  color: #94a3b8;
  margin-top: 2px;
}

/* ---- FINAL CTA ---- */

.v-final {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.v-final-title {
  font-family: 'Inter', sans-serif;
  font-size: 2.8rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.2;
  max-width: 600px;
  margin: 0 auto 1rem;
}

.v-final-sub {
  font-family: 'Inter', sans-serif;
  font-size: 1.8rem;
  color: #64748b;
  margin: 0 auto;
}

.v-final-alt {
  display: inline-block;
  margin-top: 1.4rem;
  font-family: 'Inter', sans-serif;
  font-size: 1.4rem;
  color: #94a3b8;
  text-decoration: none;
}
.v-final-alt:hover { color: #2563eb; text-decoration: underline; }

/* ---- MISC ---- */

.btn {
  font-size: 1.6rem;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
}

#pricing { color: inherit; }

/* ---- FEATURED ON ---- */

.v-featured {
  background: #f8fafc;
  padding: 3rem 0 4rem;
}

.v-featured-hd {
  text-align: center;
  margin-bottom: 2.4rem;
}

.v-featured-label {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #cbd5e1;
  margin: 0;
}

.featured-marquee {
  overflow: hidden;
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    #000 4rem,
    #000 calc(100% - 4rem),
    transparent
  );
  mask-image: linear-gradient(
    to right,
    transparent,
    #000 4rem,
    #000 calc(100% - 4rem),
    transparent
  );
}

.featured-track {
  display: flex;
  width: max-content;
  animation: featured-scroll 240s linear infinite;
}

.featured-track:hover,
.featured-track:focus-within {
  animation-play-state: paused;
}

.featured-group {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding-right: 2rem;
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.featured-link {
  display: block;
  opacity: 0.2;
  transition: opacity 0.3s ease;
}

.featured-link:hover,
.featured-link:focus-visible {
  opacity: 0.65;
}

.featured-link img {
  height: 36px;
  width: auto;
}

@keyframes featured-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .featured-track {
    animation: none;
  }
  .featured-marquee {
    overflow-x: auto;
    -webkit-mask-image: none;
    mask-image: none;
  }
  .featured-link {
    opacity: 0.6;
  }
}

/* ---- FOOTER ---- */

#footer {
  padding: 4rem 0 !important;
  background: #1c2538;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 0 1rem;
}

.footer-bottom__left {
  text-align: left;
}

.footer-bottom__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.2rem;
  margin-bottom: 0.8rem;
}

.footer-bottom__link {
  color: #94a3b8;
  font-size: 1.4rem;
  text-decoration: none;
  font-family: 'Inter', sans-serif;
  transition: color 0.15s ease;
}

.footer-bottom__link:hover {
  color: #fff;
  text-decoration: underline;
}

.footer-bottom__sep {
  color: #64748b;
  font-size: 1.4rem;
}

.footer-bottom__copyright {
  margin: 0;
  font-size: 1.3rem;
  color: #64748b;
  font-family: 'Inter', sans-serif;
}

.footer-bottom__social {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
  gap: 1.2rem;
}

.footer-bottom__social--item {
  color: #94a3b8;
  font-size: 2rem;
  transition: color 0.15s ease;
}

.footer-bottom__social--item:hover {
  color: #fff;
}

</style>
